import React from "react";
import { pluckYearValues } from "../utils";

const LeaderRow = ({ data, position }) => {
  const { image, display_title } = data;
  const yearlyValues = pluckYearValues(data);

  return (
    <tr>
      <td>
        <span>
          <strong>{position}</strong>
          <img src={image} width="38" height="38" />
          {display_title}
        </span>
      </td>
      <td>
        <span>{yearlyValues.previous}</span>
      </td>
      <td>
        <span>{yearlyValues.current}</span>
      </td>
      <td>
        <span className="percentage">{yearlyValues.difference}</span>
      </td>
    </tr>
  );
};

export default LeaderRow;
